import React from 'react';
import '../styles.scss';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useNumberFormatter } from '../../../../hooks/useNumberFormatter';
import { useTranslation } from 'react-i18next';

function ChartProgressBarReport({ completed, totalAmount, disbursmentAmount, completedLabel, pendingLabel }) {
    const { t } = useTranslation();
    const { formatNumber } = useNumberFormatter();
    const pendingAmount = totalAmount - disbursmentAmount || 0;

    return (
        <div className='c-progress-bar'>
            <div className='c-linear_porcent-data'>
                <div className='content-data report-content-data'>
                    <p className='elapsed-time-text'>{completedLabel}</p>
                </div>

                <div className='content-data report-content-data'>
                    <p className='pending-time-text'>{pendingLabel}</p>
                </div>
            </div>
            <LinearProgress
                className='linear-chart'
                variant="determinate"
                value={Math.max(0, Math.min(completed, 100))}
                style={{ width: '100%' }} />

            <div className='c-linear_porcent-data'>
                <div className='initial-content-data'>
                    <p className="completed-percent">
                        <b>{completed} %</b>
                    </p>
                    <div className='amount'>
                        {formatNumber(disbursmentAmount)} {t('dolar_sign')}
                    </div>

                </div>

                <div className='pending-content-data'>
                    <p className="completed-percent">
                        <b>{(totalAmount === 0 && pendingAmount === 0) ? 0 : 100 - completed} %</b>
                    </p>
                    <div className='amount'>
                        {formatNumber(pendingAmount)} {t('dolar_sign')}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ChartProgressBarReport;